import { Link } from 'react-router-dom';
import './FeedCardNew.css';
import './FeedCardNewTeaser.css';
import { useEffect, useRef, useState } from 'react';
import { RiVerifiedBadgeFill } from "react-icons/ri";
import posterImg from "../image/loadingshimmer.png";
import { API_BASE_URL } from '../../utils';



export default function FeedCardNewTeaser({ data, onFullModeClick }) {

    const url = `${API_BASE_URL}/master/assets/uploads/`;
    const videoRef = useRef(null);

    // Local state synced with localStorage
    const [isMuted, setIsMuted] = useState(() => {
        const stored = localStorage.getItem("isMuted");
        return stored ? JSON.parse(stored) : true;
    });

    const [isVisible, setIsVisible] = useState(false);


    // Handle mute toggle
    const handleMute = () => {

        const newMute = !isMuted;
        localStorage.setItem("isMuted", JSON.stringify(newMute));
        setIsMuted(newMute);
    };

    // Watch visibility
    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setIsVisible(entry.isIntersecting),
            { threshold: 0.6 }
        );

        if (videoRef.current) {
            observer.observe(videoRef.current);
        }

        return () => {
            if (videoRef.current) {
                observer.unobserve(videoRef.current);
            }
        };
    }, []);

    // Control video playback and mute state
    useEffect(() => {
        const video = videoRef.current;
        const stored = localStorage.getItem("isMuted");
        if (video) {
            video.muted = stored === "true" ? true : false;
            if (isVisible) {
                video.play().catch(() => { });
            } else {
                video.pause();
            }
        }
    }, [isVisible, isMuted]);




    return (
        <div className="feed-card" onClick={onFullModeClick}>
            {/* Header */}



            <div className='feed-card-image-content-section-wrapper'>

                <div className="feed-card-header">
                    <Link to={`/${data?.meta?.slug}`}>
                        <div>
                            <img
                                className="feed-card-avatar"
                                src={url + data?.clubLogo}
                                alt="Club"
                            />
                        </div>
                    </Link>
                    <div className="feed-card-header-details">
                        <Link to={`/${data?.meta?.slug}`}>
                            <h4> {data?.clubName}  <span className="verified-badge"><RiVerifiedBadgeFill />
                                {/* <span className='feed-last-seen'>{data?.category}</span> */}
                            </span>
                            </h4>
                        </Link>
                        <p>{data?.areaName} {","} {data?.cityName}</p>
                    </div>
                    <div className="feed-card-more"><i
                        class=
                        "fi fi-br-menu-dots" style={{ fontSize: '17px' }}
                    ></i></div>
                </div>


                <div className='feed-card-image-content-section'>

                    {/* Banner Carousel */}
                    <div className="feed-card-carousel">
                        <div className="carousel-label">Add On up to 50% Extra on Food & Beverages</div>

                        <div className='feed-event-video'>
                            <video
                                ref={videoRef}
                                src={url + data?.video}
                                poster={posterImg}
                                autoPlay
                                muted={localStorage.getItem("isMuted") === "true" ? true : false}
                                loop
                                playsInline
                                className="live-card-video"
                            >
                                <source src={url + data?.video} type="video/mp4" />
                            </video>
                            {/* <div className='feed-event-video-overlay'>
                                <div className="book-now-teaser">
                                    <i class="fi fi-rr-play  play-icon-teaser"></i>
                                </div>
                            </div> */}
                            <div className='feed-event-video-icon-mute' onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                handleMute();
                            }}>
                                {localStorage.getItem("isMuted") === "true" ? <i class="fi fi-rr-volume-mute volume-icon"></i> : <i class="fi fi-rr-volume volume-icon"></i>}

                            </div>
                        </div>

                        <Link to="/package-lead-form">
                            <div className="carousel-actions-section">
                                <div className="feed-book-now">Reserve Now</div>
                                <i class="fi fi-br-angle-right"></i>
                            </div>
                        </Link>
                        <div className="feed-card-content">
                            <h3>{data?.clubName}</h3>
                            <p>{data?.meta?.address}</p>
                        </div>
                    </div>
                    {/* Footer Actions */}
                    <div className="feed-card-actions-event">
                        <div className="feed-card-icons-section" style={{ pointerEvents: 'none' }}>
                            <div className='feed-card-icon-box'>
                                <i class="fi fi-tr-circle-star feed-icons-new-card"></i>
                            </div>
                            {/* <div className='feed-card-icon-box' >
                                <i class="fi fi-rr-bookmark feed-icons-new-card"></i>
                            </div> */}
                        </div>
                        <div className="feed-card-icons-section" style={{ pointerEvents: 'none' }}>
                            {/* <div className='feed-card-icon-box'><i class="fi fi-rr-heart feed-icons-new-card"></i> --</div>
                            <div className='feed-card-icon-box'><i class="fi fi-rr-comment feed-icons-new-card"></i> --</div>
                            <div className='feed-card-icon-box'><i class="fi fi-rr-paper-plane feed-icons-new-card"></i> --</div> */}
                        </div>
                    </div>
                </div>
                {/* Content */}




            </div>
        </div>
    );
}
